import React, { useRef } from "react";
import AutoScroll from "embla-carousel-auto-scroll";
import useEmblaCarousel from "embla-carousel-react";
import { sectionFrame } from "../../config/site";
import { friendLogos } from "../../content/site";

export function FriendsSection() {
    const autoScroll = useRef(
        AutoScroll({
            direction: "forward",
            playOnInit: true,
            speed: 0.9,
            startDelay: 0,
            stopOnInteraction: false,
            stopOnMouseEnter: false,
            stopOnFocusIn: false,
        })
    );
    const [emblaRef] = useEmblaCarousel(
        {
            align: "start",
            dragFree: true,
            loop: true,
        },
        [autoScroll.current]
    );

    return (
        <section
            className="relative mt-[110px] pb-[32px] pt-[110px] max-[639px]:mt-[84px] max-[639px]:pb-[20px] max-[639px]:pt-[84px]"
            aria-label="Партнеры конференции"
        >
            <div
                className="pointer-events-none absolute right-[-220px] top-[32px] h-[420px] w-[520px] rounded-full bg-[#96EA28]/35 blur-[160px] max-[639px]:right-[-180px] max-[639px]:top-[48px] max-[639px]:h-[260px] max-[639px]:w-[280px] max-[639px]:blur-[110px]"
                aria-hidden="true"
            />
            <div className={sectionFrame}>
                <h2 className="m-0 pb-8 text-[56px] font-bold uppercase leading-none tracking-[-0.04em] text-white max-[639px]:pb-5 max-[639px]:text-[31px] max-[639px]:leading-[1]">
                    Партнеры конференции
                </h2>
            </div>
            <div
                ref={emblaRef}
                className="h-[79px] overflow-hidden max-[639px]:h-[60px]"
                aria-label="Партнеры конференции"
            >
                <div className="flex h-full touch-pan-y select-none items-center -ml-[88px] max-[639px]:-ml-[40px]">
                    {friendLogos.map((logo, index) => (
                        <div
                            key={`${logo.src}-${index}`}
                            className="flex h-full min-w-0 flex-[0_0_auto] items-center pl-[88px] max-[639px]:pl-[40px]"
                        >
                            <img
                                src={logo.src}
                                alt={logo.alt}
                                width={logo.width}
                                height={logo.height}
                                className="block h-auto max-h-[44px] w-auto max-w-none shrink-0 max-[639px]:max-h-[32px]"
                                decoding="async"
                                draggable={false}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
